import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import { css } from 'emotion'
import { get } from '../util/Mappers'
import { Link } from '@reach/router'
import { Menu } from 'semantic-ui-react'

export const styles = {}
styles.linkContainer = css`
  display: flex;
  .active.item a {
    color: black;
  }
  .ui.menu {
    width: 100%;
  }
`

/**
 * Makes a split-join mapping to prettify page names.
 * @param {string} link
 * @returns {string}
 */
function prettify(link) {
  return link.replace(/-/g, ' ')
    .split(' ')
    .map(segment => segment[0].toUpperCase() + segment.slice(1))
    .join(' ');
}

export const Links = ({ active }) => (
  <StaticQuery
    query={graphql`
      query ListPagesLinks {
        pages: allFile(
          filter: {
            sourceInstanceName: { eq: "pages" }
            name: { nin: ["index", "404"] }
          }
        ) {
          edges {
            node {
              name
            }
          }
        }
      }
    `}
    render={({ pages }) => (
      <div className={styles.linkContainer}>
        <Menu tabular>
          {pages.edges
            .map(get`node`)
            .map(get`name`)
            .map(link => (
              <Menu.Item key={link} active={active === link}>
                <Link to={link}>{prettify(link)}</Link>
              </Menu.Item>
            ))}
        </Menu>
      </div>
    )}
  />
)
